import { render, staticRenderFns } from "./proformaclient_add_direct.vue?vue&type=template&id=975c8cc2&scoped=true&"
import script from "./proformaclient_add_direct.vue?vue&type=script&lang=js&"
export * from "./proformaclient_add_direct.vue?vue&type=script&lang=js&"
import style0 from "./proformaclient_add_direct.vue?vue&type=style&index=0&id=975c8cc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975c8cc2",
  null
  
)

export default component.exports